import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import Indexpage from '../views/Language.vue'

const routes = [
  
  {
    path: '/',
    name: 'home',
    component: Indexpage
  }
  ,
   {
    path: '/:pageId',
    name: 'homewithId',
    component: Indexpage
  }
  ,
  {
    path: '/mobile',
    name: 'mobile',
    component: () => import(/* webpackChunkName: "mobile" */ '../views/pages/Mobile.vue')
  },
  {
    path: '/:lang/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "mobile" */ '../views/pages/Login.vue')
  },
  {
    path: '/:lang/login/:pageId',
    name: 'loginWithId',
    component: () => import(/* webpackChunkName: "mobile" */ '../views/pages/Login.vue')
  },
  {
    path: '/:lang/search',
    name: 'Search',
    component: () => import(/* webpackChunkName: "mobile" */ '../views/pages/Search.vue')
  },
  {
    path: '/:lang/scan',
    name: 'Scan',
    component: () => import(/* webpackChunkName: "mobile" */ '../views/pages/Scan.vue')
  },
  {
    path: '/:lang/favorites/:pageId',
    name: 'Favorites',
    component: () => import(/* webpackChunkName: "mobile" */ '../views/pages/Favorites.vue')
  },
  {
    path: '/:lang/navigation/:pageId',
    name: 'navigation',
    component: () => import(/* webpackChunkName: "mobile" */ '../views/pages/Navigation.vue')
  }
  ,
  {
    path: '/:lang/visit/:pageId',
    name: 'Visit',
    component: () => import(/* webpackChunkName: "mobile" */ '../views/pages/Visit.vue')
  }
  ,
  {
    path: '/:lang/route/:pageId',
    name: 'Route',
    component: () => import(/* webpackChunkName: "mobile" */ '../views/pages/Route.vue')
  }
  ,
  {
    path: '/:lang/map/:pageId',
    name: 'Map',
    component: () => import(/* webpackChunkName: "mobile" */ '../views/pages/Map.vue')
  }
  ,
  {
    path: '/:lang/feedback/:pageId',
    name: 'Feedback',
    component: () => import(/* webpackChunkName: "mobile" */ '../views/pages/Feedback.vue')
  }
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
